import Vue from "vue";
import App from "./App.vue"; 
import router from "./router";
import Message from "./components/message/main.js"
import Vuex from 'vuex'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
 import "agora-rtc-vue/lib/agora-rtc-vue.css";
import AgoraRtcVue from "agora-rtc-vue/lib/agora-rtc-vue.umd"; 

//import vsLoading from './components/vsLoading/Base/index.ts'
Vue.config.productionTip = false;

Vue.prototype.$message = Message;
import i18n from './i18n/index.js'
import { hanldeLang } from './i18n/index.js'
//console.log(AgoraRtcVue);
Vue.use(Vuex)
Vue.use(AgoraRtcVue, {});
 


const store=new Vuex.Store({
  strict: process.env.DEV,
});

hanldeLang()

new Vue({
  router,
  i18n,
 // store,
  render: h => h(App)
}).$mount("#app");
